import { withLayout } from '../../layout';

import DataSync from './data-sync.page';

export default withLayout(DataSync);
